<script>
  import { createEventDispatcher, onDestroy } from 'svelte';
  import { multicast } from '../store';
  import { useSpotlightHighlight, onDismiss } from './SpotlightRoot.svelte';

  const dispatch = createEventDispatcher();
  const spotlightHighlight = useSpotlightHighlight();

  export let testid = undefined;
  export let auto = true;
  export let highlight = false;

  const highlight$ = multicast(highlight, [spotlightHighlight]);
  $: highlight = $highlight$;

  export function show() {
    if (!$highlight$) {
      $highlight$ = true;
      dispatch('show');
    }
  }

  export function hide() {
    if ($highlight$) {
      $highlight$ = false;
      dispatch('hide');
    }
  }

  function autoshow() {
    if (!auto) {
      return;
    }
    show();
  }

  function autohide() {
    if (!auto) {
      return;
    }
    hide();
  }

  function spotlight(node) {
    const computedStyle = window.getComputedStyle(node);
    if (computedStyle.position === 'static') {
      // eslint-disable-next-line no-param-reassign
      node.style.position = 'relative';
    }

    const destroy = highlight$.subscribe((isHighlighted) => {
      // eslint-disable-next-line no-param-reassign
      node.style.zIndex = isHighlighted ? 1 : 0;
    });

    return { destroy };
  }

  onDismiss(hide);
  onDestroy(hide);
</script>

<div
  class='spotlight'
  on:mouseenter={autoshow}
  on:mouseleave={autohide}
  on:focusin={autoshow}
  on:focusout={autohide}
  data-cy={testid}>
  <slot {spotlight} {show} {hide} highlight={$highlight$} />
</div>

<style>
  .spotlight { display: contents; }
</style>
